const CallPlayerModule = {
    namespaced: true,
    state: () => ({
        currentCall: null,
        isOpen: false,
        isPlaying: false,
        playbackRate: 1,
    }),

    getters: {
        currentCall(state) {
            return state.currentCall;
        },
        isOpen(state) {
            return state.isOpen;
        },
        isPlaying(state) {
            return state.isPlaying;
        },
        playbackRate(state) {
            return state.playbackRate;
        },
    },
    mutations: {
        setCurrentCall(state, call) {
            state.currentCall = call;
        },
        setOpen(state, isOpen) {
            state.isOpen = isOpen;
        },
        setPlaying(state, isPlaying) {
            state.isPlaying = isPlaying;
        },
        setPlaybackRate(state, rate) {
            state.playbackRate = rate;
        },
    },
    actions: {
        setCurrentCall(context, call) {
            context.commit('setCurrentCall', call);
        },
        setOpen(context, isOpen) {
            context.commit('setOpen', isOpen);
        },
        close(context) {
            context.commit('setOpen', false);
        },
        setPlaying(context, isPlaying) {
            context.commit('setPlaying', isPlaying);
        },
        setPlaybackRate(context, rate) {
            context.commit('setPlaybackRate', rate);
        },
    },
}

export default CallPlayerModule;
